export const setConsentState = (isEnabled) => {
    if (isEnabled) {
        window.dataLayer.push({ event: 'CookieConsent' });
    }
};
